import React from 'react';
import SelectStructure from '../../../Components/SelectStructure/SelectStructure';

interface SupportStructureSelectorProps {
    value: string;
    onChange: (value: string) => void;
    label: string;
    placeholder: string;
    errorMessage: string;
}

export const SupportStructureSelector: React.FC<
    SupportStructureSelectorProps
> = ({ onChange, label, placeholder }) => {
    return (
        <div className="col-12 mt-2">
            <SelectStructure
                defaultOption={placeholder}
                label={label}
                onSelectionChange={onChange}
            />
        </div>
    );
};
